import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.number.constructor.js";
import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import HubAssetViewer from './HubAssetViewer';
import { Provider as AssetViewerContextProvider } from 'screens/AssetViewerUI/hooks/useAssetViewerContext';
import useAssetViewerQueryParams from 'screens/AssetViewerUI/hooks/useAssetViewerQueryParams';
function AssetViewerFromQuery() {
  var _useAssetViewerQueryP = useAssetViewerQueryParams('asset'),
    _useAssetViewerQueryP2 = _slicedToArray(_useAssetViewerQueryP, 2),
    params = _useAssetViewerQueryP2[0],
    removeParams = _useAssetViewerQueryP2[1];

  // Using useRouteMatch in place of useParams as the context provider is outside the Route path scope
  var path = useRouteMatch('/playlists/:id');
  var _ref = (path === null || path === void 0 ? void 0 : path.params) || {},
    playlistId = _ref.id;
  var parentPlaylistId = params.playlistId || playlistId && Number(playlistId) || null;
  if (!(params !== null && params !== void 0 && params.assetId)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(AssetViewerContextProvider, {
    assetId: params.assetId,
    playlistId: parentPlaylistId,
    isPublished: params.isPublished
  }, /*#__PURE__*/React.createElement(HubAssetViewer, {
    onClose: removeParams
  }));
}
export default AssetViewerFromQuery;